import {FeaturesEnum, HomeEnum} from 'presentation/constants';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import React from 'react';
import {Navigate} from 'react-router-dom';
import {useContractStatus} from 'presentation/hooks';
import {ProcedureSelection} from './pages/ProcedureSelection';
import {useAccountInformation} from 'presentation/pages';

export function ProcedureSelectionWrapper() {
	const {isValid} = useContractStatus();
	const {isB2BAccess} = useAccountInformation();

	const {isEnabled: isExamsSpecialtyProcedureFlagEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_EXAMS_SPECIALTY_PROCEDURE,
	);
	const {isEnabled: isSemanticSearchEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_SEMANTIC_SEARCH_MEDICAL_GUIDE,
	);

	const shouldRedirectToHome =
		!isExamsSpecialtyProcedureFlagEnabled ||
		!isSemanticSearchEnabled ||
		!isValid ||
		isB2BAccess;

	if (shouldRedirectToHome) {
		return <Navigate to={HomeEnum.HOME_PAGE} replace />;
	}

	return <ProcedureSelection />;
}
